import { ColumnProps } from './interface'

export default {
  name: 'ATableColumn',
  props: ColumnProps,
}



// WEBPACK FOOTER //
// ./components/table/Column.jsx